<template>
  <PageLayout>
    <template #headerTitle>Profile</template>
    <ProfilePageContent />
  </PageLayout>
</template>
